"use client";

export { useNotificationContext as useNotifications } from "@/app/components/notifications/NotificationProvider";
